import { z } from 'zod';
import { paginationInput, sortInput, periodoInput, idInput } from './common';

export const contaTipoEnum = z.enum(['PAGAR', 'RECEBER']);
export const contaStatusEnum = z.enum(['PENDENTE', 'PAGO', 'VENCIDO', 'CANCELADO']);

export const listContasInput = paginationInput.merge(sortInput).merge(periodoInput).extend({
  tipo: contaTipoEnum.optional(),
  status: contaStatusEnum.optional(),
  campanhaId: z.string().uuid().optional(),
  search: z.string().optional(),
});

// Helper para transformar string vazia em undefined
const emptyStringToUndefined = z.string().transform((val) => val === '' ? undefined : val);

export const createContaInput = z.object({
  descricao: z.string().min(3, 'Descrição deve ter no mínimo 3 caracteres'),
  valor: z.string(),
  tipo: contaTipoEnum,
  status: contaStatusEnum.default('PENDENTE'),
  dataVencimento: z.string().min(1, 'Data de vencimento é obrigatória'),
  dataPagamento: emptyStringToUndefined.optional(),
  campanhaId: emptyStringToUndefined.optional(),
});

export const updateContaInput = idInput.extend({
  descricao: z.string().min(3).optional(),
  valor: z.string().optional(),
  tipo: contaTipoEnum.optional(),
  status: contaStatusEnum.optional(),
  dataVencimento: z.string().optional(),
  dataPagamento: z.string().optional(),
  campanhaId: z.string().uuid().nullable().optional(),
});

export const anexarArquivoInput = z.object({
  contaId: z.string().uuid(),
  nomeArquivo: z.string(),
  tipoArquivo: z.string(),
  urlArquivo: z.string().url(),
});

export const contaOutput = z.object({
  id: z.string(),
  descricao: z.string(),
  valor: z.string(),
  tipo: contaTipoEnum,
  status: contaStatusEnum,
  dataVencimento: z.string(),
  dataPagamento: z.string().nullable(),
  campanhaId: z.string().nullable(),
  userId: z.string(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const anexoOutput = z.object({
  id: z.string(),
  contaId: z.string(),
  nomeArquivo: z.string(),
  urlArquivo: z.string(),
  tipoArquivo: z.string(),
  createdAt: z.date(),
});

export type ListContasInput = z.infer<typeof listContasInput>;
export type CreateContaInput = z.infer<typeof createContaInput>;
export type UpdateContaInput = z.infer<typeof updateContaInput>;
export type AnexarArquivoInput = z.infer<typeof anexarArquivoInput>;
export type ContaOutput = z.infer<typeof contaOutput>;
export type AnexoOutput = z.infer<typeof anexoOutput>;
